module.exports = __webpack_public_path__ + "static/media/weight.b3cf59d7.svg";